import type { FC } from 'react';
import React from 'react';
import { Typography } from '@mui/material';
import { Button } from '@pflegenavi/web-components';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { fmAppMainPages } from '@pflegenavi/frontend/routing';
import { InfoBoxContainer } from '../InfoBox';
import AllSetImage from '../../../assets/undraw-setup-up-direct-debit.svg';

type DirectDebitInactiveInfoBoxProps = Record<never, never>;

export const DirectDebitInactiveInfoBox: FC<
  DirectDebitInactiveInfoBoxProps
> = () => {
  return (
    <InfoBoxContainer
      showWelcomeMessage
      image={
        <img src={AllSetImage} alt="" width={210} style={{ marginTop: -30 }} />
      }
      content={<DirectDebitInactiveContent />}
    />
  );
};

const DirectDebitInactiveContent: FC = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  return (
    <>
      <Typography variant="subtitle1" sx={{ mb: 2 }}>
        {t('mobile.family-member.set-up-now-description')}
      </Typography>

      <Button
        variant="contained"
        onClick={() => navigate(fmAppMainPages.DIRECT_DEBIT)}
      >
        {t('mobile.family-member.set-up-now')}
      </Button>
    </>
  );
};
